import { ArrowUpRightIcon as ArrowUpRight } from "@phosphor-icons/react/dist/csr/ArrowUpRight";
import type { CSSProperties } from "react";

export type StorefrontFooterSection = {
  label: string;
  links: Array<{ title: string; href: string }>;
};

type StorefrontFooterProps = {
  navigationLabel: string;
  tagline: string;
  craft: string;
  scope: string;
  rights: string;
  sections: StorefrontFooterSection[];
  navigate: (path: string) => void;
};

export function StorefrontFooter({
  navigationLabel,
  tagline,
  craft,
  scope,
  rights,
  sections,
  navigate,
}: StorefrontFooterProps) {
  return (
    <footer className="site-footer">
      <div className="site-footer__glow" aria-hidden="true" />
      <div className="site-footer__grid">
        <div className="site-footer__brand reveal-item">
          <a
            className="footer-brand"
            href="/"
            onClick={(event) => {
              if (!event.ctrlKey && !event.metaKey && event.button === 0) {
                event.preventDefault();
                navigate("/");
              }
            }}
          >
            <img
              className="brand__logo"
              src="/brand/zoya-hub-lockup.webp"
              alt="Zoya Hub"
              width="103"
              height="72"
              loading="lazy"
            />
            <span>
              <small>{tagline}</small>
            </span>
          </a>
          <p>{craft}</p>
          <small>{scope}</small>
        </div>

        <nav className="site-footer__navigation" aria-label={navigationLabel}>
          {sections.map((section, index) => (
            <section
              className="footer-link-group reveal-item"
              style={{ "--footer-delay": `${index * 80}ms` } as CSSProperties}
              key={section.label}
            >
              <h2>{section.label}</h2>
              <ul>
                {section.links.map((link) => (
                  <li key={`${link.href}-${link.title}`}>
                    <a
                      href={link.href}
                      onClick={(event) => {
                        if (
                          !event.ctrlKey &&
                          !event.metaKey &&
                          event.button === 0
                        ) {
                          event.preventDefault();
                          navigate(link.href);
                        }
                      }}
                    >
                      {link.title}
                      <ArrowUpRight aria-hidden="true" />
                    </a>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </nav>
      </div>

      <div className="site-footer__closing">
        <p>
          © {new Date().getFullYear()} Zoya Hub. {rights}
        </p>
        <span aria-hidden="true">ZOYA</span>
      </div>
    </footer>
  );
}
